import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

import { PlycaDataService } from '../../services/plyca.service';
import { BaseComponent } from '../components/common/baseComponent/base.component';
import { BaseWidget } from './baseWidget';

@Component({
  selector: 'widget',
  templateUrl: 'widget.template.html'
})
export class widgetComponent extends BaseWidget {
  // @Input() estilos: string; //  = 'style1 bg-azul1';
  // @Input() descriptionKey; //  = 'Eventos';
  @Input() num: number; //  = 4;
  // @Input() icon: string; //  = 'fa-clock-o';
  // @Input() layoutClass: string;

  // // para la navegacion
  // @Input() link: string;
  // @Input() linkParamName: string; //  = 'TIPO_TAREA';
  // @Input() linkParamValue: string; //  = 'TIPO_TAREA';


  // el componente puede recibir directamente los datos, o bien el identificador de un atributo para consultarlos
  @Input() attributeId: string;

  loading = true;
  error = false;
  empty = false;

  constructor(public plycaService: PlycaDataService, private router: Router) {
    super();
  }

  // ngAfterContentInit(): void {
  //   super.ngAfterContentInit();
  //   // CARGA DE DATOS UTILIZANDO ATRIBUTOS
  //   this.reloadWidget();
  // }

  reloadWidget(filterStr?: string) {
    if (this.attributeId) {
      this.subscribe(this.plycaService.getAttributeValue(this.attributeId, filterStr),
        x => {
          if (x.values) {
            let datos: Array<any> = x.values;
            // se comprueba si el servicio ha devuelto datos
            this.empty = (datos.length === 0);
            // este tipo de componente solamente tiene que recibir un dato. Si no hay un error en la definicion del atributo
            // 						this.error = (datos.length > 0);
            // si todo ok, recuperamos los datos
            if (!this.empty && !this.error) {
              this.descriptionKey = datos[0].columns.DESCRIPTION.value;
              this.num = datos[0].columns.CUENTA.value;
            }
          }
        },
        err => {
          console.log('Error cargando widget: ' + this.attributeId);
          console.log(err);
          this.error = true;
          this.loading = false;
        },
        () => this.loading = false);
    } else {
      // TODO: PRUEBA CON DATOS RECIBIDOS COMO PARAMETRO
      // 			this.chartData = [150, 200, 341, 400];
      // 			this.chartLabels = ['Abierto', 'Negociado','Contrato Menor','Acuerdo Marco'];
      // 			this.empty = (this.chartData.length == 0);
    }
  }

  navigate() {
    console.log('navigate: ' + this.link)
    if (this.link) {
      let params = {};
      if (this.linkParamName && this.linkParamValue) {
        params[this.linkParamName] = this.linkParamValue;
      }
      this.router.navigate([this.link], { queryParams: params });
    }
  }

  isLoading(): boolean {
    return this.loading;
  }

  isError(): boolean {
    return this.error;
  }

  isOK(): boolean {
    return !this.loading && !this.error && !this.empty;
  }

  isEmpty(): boolean {
    return this.empty;
  }
}
